jQuery(document).on("swup:pageView", function () {
  $ = jQuery;

  if ($("body.home").length) {
    var isMobile = window.matchMedia("only screen and (max-width: 949px)").matches;

    setTimeout(function () {
      // Highlighter Hero
      setTimeout(() => {
        $(".home-hero .title span.blue-bg").addClass("active-highlight");
      }, 1500);

      setTimeout(() => {
        setInterval(function () {
          // $(".liveEvents").toggleClass("liveEventsActive");
          $(".home-hero .title span.blue-bg > span.blue-word").toggleClass("glitch");
        }, 2000);
      }, 2000);
    }, 2000);

    // Home Hero Giphy Looper
    function looper() {
      if ($('.bad-things .badgif:not(".active")').first().addClass("active").length) {
        // console.log("looping");
        setTimeout(looper, isMobile ? 800 : 1200);
      } else {
        $(".bad-things .badgif.active").removeClass("active");
        setTimeout(looper, isMobile ? 0 : 300);
      }
    }
    looper();

    // Hover for Bad Things Visibility
    $(".blue-bg").hover(
      function () {
        $(".bad-things").addClass("show");
      },
      function () {
        $(".bad-things").removeClass("show");
      }
    );

    $(".home-hero .title span.blue-bg > span.blue-word").hover(
      function () {
        $(".home-hero .title span.blue-bg > span.blue-word").addClass("glitch-hover");
      },
      function () {
        $(".home-hero .title span.blue-bg > span.blue-word").removeClass("glitch-hover");
      }
    );

    /****************************
     * ETF Slider
     *********************/
    var $etfSlider = $(".home-etfs .owl-carousel");
    var quote_count = parseInt($etfSlider.find(".slide").length);
    $etfSlider.owlCarousel({
      loop: false,
      rewind: true,
      nav: true,
      navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="25.699" height="21.698" viewBox="0 0 25.699 21.698"><path id="Arrow" d="M26.284,14.506,24.5,12.719,17.41,19.793V.156H14.874V19.793L7.8,12.706,6,14.506,16.142,24.648Z" transform="translate(0.344 26.991) rotate(-90)" fill="none" stroke="#212121" stroke-width="1"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="25.699" height="21.698" viewBox="0 0 25.699 21.698"><path id="Arrow" d="M26.284,14.506,24.5,12.719,17.41,19.793V.156H14.874V19.793L7.8,12.706,6,14.506,16.142,24.648Z" transform="translate(0.344 26.991) rotate(-90)" fill="none" stroke="#212121" stroke-width="1"/></svg>'],
      items: 1,
      singleItem: true,
      margin: 0,
      dots: true,
      autoHeight: false,
      smartSpeed: 600,
      checkVisibility: true,
      onInitialize: function (e) {
        // Check if only one slide in carousel

        if (quote_count == 1) {
          // console.log("only one");
          this.options.loop = false;
          this.options.nav = false;
          this.options.mouseDrag = false;
        } else {
          this.options.loop = false; // Changed for rewind fix can change back if needed
          this.options.nav = true;
          this.options.mouseDrag = true;
        }
      },
      // responsive: {
      //   0: {
      //     items: 1,
      //   },
      //   768: {
      //     dots: true,
      //     nav: true,
      //   },
      // },
    });
    $(window).on("resize", function () {
      $(".home-etfs .owl-carousel .owl-stage-outer").width(innerWidth);
    });
  }

  if ($(".page-loader").length) {
    /*****************************************************************
     * Splash page welcome timeout
     *****************************************************************/
    setTimeout(function () {
      $(".page-loader").addClass("loader-inactive");
    }, 2000);
  }
});
